import { IconBuild } from '@bitrise/bitkit-v2';
import { Text } from '@chakra-ui/react/text';

import BuildListSkeletonOverlayContent from '../../../components/BuildListItem/BuildListSkeletonOverlayContent';

const BuildListEmptyContent = () => (
  <BuildListSkeletonOverlayContent color="text/primary">
    <IconBuild width="40px" height="40px" />
    <Text textStyle="heading/h2">You don&apos;t have any builds.</Text>
  </BuildListSkeletonOverlayContent>
);

export default BuildListEmptyContent;
